import React from 'react';
import { Video, FileText, CheckSquare, ArrowRight } from 'lucide-react';

export default function WelvateMethodSection() {
  const steps = [
    {
      number: "1",
      icon: <Video className="w-5 h-5 text-[#16325B]" />,
      title: "Understand",
      desc: "Short, plain-language lessons that decode markets, funds and money decisions at your pace."
    },
    {
      number: "2",
      icon: <FileText className="w-5 h-5 text-[#16325B]" />,
      title: "Apply",
      desc: "Put ideas to work with journals, calculators and real scenarios — before real money is at stake."
    },
    {
      number: "3",
      icon: <CheckSquare className="w-5 h-5 text-[#16325B]" />,
      title: "Compound",
      desc: "Turn knowledge into habits: disciplined investing that grows quietly, year after year."
    }
  ];

  return (
    <section id="method" className="py-16 pt-16 border-t border-gray-200/80 px-6 max-w-7xl mx-auto font-sans">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
        
        {/* Left Info Column */}
        <div className="lg:col-span-4 space-y-4 pr-0 lg:pr-4">
          <h2 className="font-serif-title text-4xl font-bold text-[#0A2540] leading-tight">
            The Welvate Method
          </h2>
          <p className="text-gray-500 text-sm leading-relaxed max-w-sm">
            Three habits that turn financial knowledge into lasting wealth.
          </p>
          <div className="pt-2">
            <a 
              href="#learning" 
              className="inline-flex items-center gap-1.5 text-[#16325B] font-bold text-sm hover:underline"
            >
              Start the journey <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>

        {/* Right 3 Cards Grid */}
        <div className="lg:col-span-8 grid grid-cols-1 md:grid-cols-3 gap-6">
          {steps.map((step, index) => (
            <div 
              key={index} 
              className="relative bg-white border border-gray-200/90 rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow duration-300 flex flex-col justify-between h-48"
            >
              {/* Number Badge overlapping top-left border */}
              <div className="absolute -left-3.5 top-6 w-7 h-7 rounded-full bg-[#16325B] text-white flex items-center justify-center text-xs font-bold shadow-sm">
                {step.number}
              </div>

              {/* Icon & Content */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-[#EEF4FA] flex items-center justify-center shrink-0">
                  {step.icon}
                </div>
                
                <div className="space-y-1.5">
                  <h3 className="font-bold text-gray-900 text-base">
                    {step.title}
                  </h3>
                  <p className="text-xs text-gray-500 leading-relaxed">
                    {step.desc}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}